<!-- ===== MAIN DASHBOARD HEADER ===== -->
<header class="main-dash-header">
  <div class="main-dash-header-inner">
    <div class="main-dash-header-left">
      <div class="main-dash-header-icon">
        <i class="pi pi-chart-line"></i>
      </div>
      <div class="main-dash-header-text">
        <h1>IIMA Executive Dashboard</h1>
        <p>Consolidated analytics across MAKE, Revenue, TDF, iDEX, PIL &amp; CFI</p>
      </div>
    </div>
  </div>
</header>

<!-- ===== TOP KPI CARDS ===== -->
<section class="main-dash-section main-dash-kpi-section" aria-label="Key performance indicators">
  <div class="main-dash-kpi-grid">
    <div class="main-dash-kpi-card main-dash-kpi-blue">
      <div class="main-dash-kpi-top">
        <span class="main-dash-kpi-icon-wrap"><i class="pi pi-inbox"></i></span>
        <div class="main-dash-kpi-content">
          <span class="main-dash-kpi-label">Total Proposals</span>
          <span class="main-dash-kpi-value">{{ kpiTotalProposals }}</span>
        </div>
      </div>
      <div class="main-dash-kpi-bottom">
        <div class="main-dash-kpi-split main-dash-kpi-split-row">
          <span class="main-dash-split-label main-dash-split-revenue">Revenue:</span><span class="main-dash-split-count">{{ kpiSplitScheme.revenue }}</span>
          <span class="main-dash-split-sep"></span>
          <span class="main-dash-split-label main-dash-split-idex">iDEX:</span><span class="main-dash-split-count">{{ kpiSplitScheme.idex }}</span>
          <span class="main-dash-split-sep"></span>
          <span class="main-dash-split-label main-dash-split-make">MAKE:</span><span class="main-dash-split-count">{{ kpiSplitScheme.make }}</span>
          <span class="main-dash-split-sep"></span>
          <span class="main-dash-split-label main-dash-split-tdf">TDF:</span><span class="main-dash-split-count">{{ kpiSplitScheme.tdf }}</span>
        </div>
        <button
          type="button"
          class="main-dash-kpi-btn main-dash-kpi-btn-icon"
          (click)="goToDetails('total-proposals')"
          pTooltip="View Details"
          tooltipPosition="left"
        >
          <i class="pi pi-arrow-right"></i>
        </button>
      </div>
    </div>

    <div class="main-dash-kpi-card main-dash-kpi-teal">
      <div class="main-dash-kpi-top">
        <span class="main-dash-kpi-icon-wrap"><i class="pi pi-file-edit"></i></span>
        <div class="main-dash-kpi-content">
          <span class="main-dash-kpi-label">Total Contracts</span>
          <span class="main-dash-kpi-value">{{ kpiTotalContracts }}</span>
        </div>
      </div>
      <div class="main-dash-kpi-bottom">
        <div class="main-dash-kpi-split main-dash-kpi-split-row">
          <span class="main-dash-split-label main-dash-split-revenue">Revenue:</span><span class="main-dash-split-count">{{ kpiSplitContracts.revenue }}</span>
          <span class="main-dash-split-sep"></span>
          <span class="main-dash-split-label main-dash-split-idex">iDEX:</span><span class="main-dash-split-count">{{ kpiSplitContracts.idex }}</span>
          <span class="main-dash-split-sep"></span>
          <span class="main-dash-split-label main-dash-split-make">MAKE:</span><span class="main-dash-split-count">{{ kpiSplitContracts.make }}</span>
          <span class="main-dash-split-sep"></span>
          <span class="main-dash-split-label main-dash-split-tdf">TDF:</span><span class="main-dash-split-count">{{ kpiSplitContracts.tdf }}</span>
        </div>
        <button
          type="button"
          class="main-dash-kpi-btn main-dash-kpi-btn-icon"
          (click)="goToDetails('total-contracts')"
          pTooltip="View Details"
          tooltipPosition="left"
        >
          <i class="pi pi-arrow-right"></i>
        </button>
      </div>
    </div>

    <div class="main-dash-kpi-card main-dash-kpi-amber">
      <div class="main-dash-kpi-top">
        <span class="main-dash-kpi-icon-wrap"><i class="pi pi-clock"></i></span>
        <div class="main-dash-kpi-content">
          <span class="main-dash-kpi-label">Total On-Going Proposals</span>
          <span class="main-dash-kpi-value">{{ kpiOnGoing }}</span>
        </div>
      </div>
      <div class="main-dash-kpi-bottom">
        <div class="main-dash-kpi-split main-dash-kpi-split-row">
          <span class="main-dash-split-label main-dash-split-revenue">Revenue:</span><span class="main-dash-split-count">{{ kpiSplitActive.revenue }}</span>
          <span class="main-dash-split-sep"></span>
          <span class="main-dash-split-label main-dash-split-idex">iDEX:</span><span class="main-dash-split-count">{{ kpiSplitActive.idex }}</span>
          <span class="main-dash-split-sep"></span>
          <span class="main-dash-split-label main-dash-split-make">MAKE:</span><span class="main-dash-split-count">{{ kpiSplitActive.make }}</span>
          <span class="main-dash-split-sep"></span>
          <span class="main-dash-split-label main-dash-split-tdf">TDF:</span><span class="main-dash-split-count">{{ kpiSplitActive.tdf }}</span>
        </div>
        <button
          type="button"
          class="main-dash-kpi-btn main-dash-kpi-btn-icon"
          (click)="goToDetails('ongoing-proposals')"
          pTooltip="View Details"
          tooltipPosition="left"
        >
          <i class="pi pi-arrow-right"></i>
        </button>
      </div>
    </div>

    <div class="main-dash-kpi-card main-dash-kpi-green">
      <div class="main-dash-kpi-top">
        <span class="main-dash-kpi-icon-wrap"><i class="pi pi-check-circle"></i></span>
        <div class="main-dash-kpi-content">
          <span class="main-dash-kpi-label">Completed Proposals</span>
          <span class="main-dash-kpi-value">{{ kpiCompleted }}</span>
        </div>
      </div>
      <div class="main-dash-kpi-bottom">
        <div class="main-dash-kpi-split main-dash-kpi-split-row">
          <span class="main-dash-split-label main-dash-split-revenue">Revenue:</span><span class="main-dash-split-count">{{ kpiSplitCompleted.revenue }}</span>
          <span class="main-dash-split-sep"></span>
          <span class="main-dash-split-label main-dash-split-idex">iDEX:</span><span class="main-dash-split-count">{{ kpiSplitCompleted.idex }}</span>
          <span class="main-dash-split-sep"></span>
          <span class="main-dash-split-label main-dash-split-make">MAKE:</span><span class="main-dash-split-count">{{ kpiSplitCompleted.make }}</span>
          <span class="main-dash-split-sep"></span>
          <span class="main-dash-split-label main-dash-split-tdf">TDF:</span><span class="main-dash-split-count">{{ kpiSplitCompleted.tdf }}</span>
        </div>
        <button
          type="button"
          class="main-dash-kpi-btn main-dash-kpi-btn-icon"
          (click)="goToDetails('completed-proposals')"
          pTooltip="View Details"
          tooltipPosition="left"
        >
          <i class="pi pi-arrow-right"></i>
        </button>
      </div>
    </div>

    <div class="main-dash-kpi-card main-dash-kpi-slate">
      <div class="main-dash-kpi-top">
        <span class="main-dash-kpi-icon-wrap"><i class="pi pi-minus-circle"></i></span>
        <div class="main-dash-kpi-content">
          <span class="main-dash-kpi-label">Short Closed Proposals</span>
          <span class="main-dash-kpi-value">{{ kpiShortClosed }}</span>
        </div>
      </div>
      <div class="main-dash-kpi-bottom">
        <div class="main-dash-kpi-split main-dash-kpi-split-row">
          <span class="main-dash-split-label main-dash-split-revenue">Revenue:</span><span class="main-dash-split-count">{{ kpiSplitShortClosed.revenue }}</span>
          <span class="main-dash-split-sep"></span>
          <span class="main-dash-split-label main-dash-split-idex">iDEX:</span><span class="main-dash-split-count">{{ kpiSplitShortClosed.idex }}</span>
          <span class="main-dash-split-sep"></span>
          <span class="main-dash-split-label main-dash-split-make">MAKE:</span><span class="main-dash-split-count">{{ kpiSplitShortClosed.make }}</span>
          <span class="main-dash-split-sep"></span>
          <span class="main-dash-split-label main-dash-split-tdf">TDF:</span><span class="main-dash-split-count">{{ kpiSplitShortClosed.tdf }}</span>
        </div>
        <button
          type="button"
          class="main-dash-kpi-btn main-dash-kpi-btn-icon"
          (click)="goToDetails('short-closed-proposals')"
          pTooltip="View Details"
          tooltipPosition="left"
        >
          <i class="pi pi-arrow-right"></i>
        </button>
      </div>
    </div>

    <div class="main-dash-kpi-card main-dash-kpi-purple">
      <div class="main-dash-kpi-top">
        <span class="main-dash-kpi-icon-wrap"><i class="pi pi-verified"></i></span>
        <div class="main-dash-kpi-content">
          <span class="main-dash-kpi-label">APSO Approved Proposals</span>
          <span class="main-dash-kpi-value">{{ kpiAspoApproved }}</span>
        </div>
      </div>
      <div class="main-dash-kpi-bottom">
        <div class="main-dash-kpi-split main-dash-kpi-split-row">
          <span class="main-dash-split-label main-dash-split-revenue">Revenue:</span><span class="main-dash-split-count">{{ kpiSplitApso.revenue }}</span>
          <span class="main-dash-split-sep"></span>
          <span class="main-dash-split-label main-dash-split-idex">iDEX:</span><span class="main-dash-split-count">{{ kpiSplitApso.idex }}</span>
          <span class="main-dash-split-sep"></span>
          <span class="main-dash-split-label main-dash-split-make">MAKE:</span><span class="main-dash-split-count">{{ kpiSplitApso.make }}</span>
          <span class="main-dash-split-sep"></span>
          <span class="main-dash-split-label main-dash-split-tdf">TDF:</span><span class="main-dash-split-count">{{ kpiSplitApso.tdf }}</span>
        </div>
        <button
          type="button"
          class="main-dash-kpi-btn main-dash-kpi-btn-icon"
          (click)="goToDetails('apso-approved-proposals')"
          pTooltip="View Details"
          tooltipPosition="left"
        >
          <i class="pi pi-arrow-right"></i>
        </button>
      </div>
    </div>

    <div class="main-dash-kpi-card main-dash-kpi-green">
      <div class="main-dash-kpi-top">
        <span class="main-dash-kpi-icon-wrap"><i class="pi pi-box"></i></span>
        <div class="main-dash-kpi-content">
          <span class="main-dash-kpi-label">PIL Items Indigenised as on Date</span>
          <span class="main-dash-kpi-value">{{ kpiPilIndigenised }}</span>
        </div>
      </div>
      <div class="main-dash-kpi-bottom">
        <div class="main-dash-kpi-split main-dash-kpi-split-row main-dash-kpi-split-empty"></div>
        <button
          type="button"
          class="main-dash-kpi-btn main-dash-kpi-btn-icon"
          (click)="goToDetails('pil-indigenised')"
          pTooltip="View Details"
          tooltipPosition="left"
        >
          <i class="pi pi-arrow-right"></i>
        </button>
      </div>
    </div>

    <div class="main-dash-kpi-card main-dash-kpi-amber">
      <div class="main-dash-kpi-top">
        <span class="main-dash-kpi-icon-wrap"><i class="pi pi-spinner"></i></span>
        <div class="main-dash-kpi-content">
          <span class="main-dash-kpi-label">PIL Items Under Indigenisation</span>
          <span class="main-dash-kpi-value">{{ kpiPilUnderIndigenisation }}</span>
        </div>
      </div>
      <div class="main-dash-kpi-bottom">
        <div class="main-dash-kpi-split main-dash-kpi-split-row main-dash-kpi-split-empty"></div>
        <button
          type="button"
          class="main-dash-kpi-btn main-dash-kpi-btn-icon"
          (click)="goToDetails('pil-under-indigenisation')"
          pTooltip="View Details"
          tooltipPosition="left"
        >
          <i class="pi pi-arrow-right"></i>
        </button>
      </div>
    </div>

    <div class="main-dash-kpi-card main-dash-kpi-blue">
      <div class="main-dash-kpi-top">
        <span class="main-dash-kpi-icon-wrap"><i class="pi pi-list"></i></span>
        <div class="main-dash-kpi-content">
          <span class="main-dash-kpi-label">Total CFI Requests</span>
          <span class="main-dash-kpi-value">{{ kpiCfiTotal }}</span>
        </div>
      </div>
      <div class="main-dash-kpi-bottom">
        <div class="main-dash-kpi-split main-dash-kpi-split-row">
          <span class="main-dash-split-label main-dash-split-cfi-pending">Pending:</span><span class="main-dash-split-count">{{ kpiCfiSplit.pending }}</span>
          <span class="main-dash-split-sep"></span>
          <span class="main-dash-split-label main-dash-split-cfi-review">In Review:</span><span class="main-dash-split-count">{{ kpiCfiSplit.inReview }}</span>
          <span class="main-dash-split-sep"></span>
          <span class="main-dash-split-label main-dash-split-cfi-closed">Closed:</span><span class="main-dash-split-count">{{ kpiCfiSplit.closed }}</span>
        </div>
        <button
          type="button"
          class="main-dash-kpi-btn main-dash-kpi-btn-icon"
          (click)="goToDetails('cfi-requests')"
          pTooltip="View Details"
          tooltipPosition="left"
        >
          <i class="pi pi-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
</section>

<!-- ===== CHART 3: Scheme Lifecycle Progress Snapshot ===== -->
<section class="main-dash-section main-dash-chart-section">
  <p-card styleClass="main-dash-chart-card">
    <ng-template pTemplate="header">
      <div class="main-dash-chart-header">
        <div>
          <h3 class="main-dash-chart-title">Scheme Lifecycle Progress Snapshot</h3>
          <p class="main-dash-chart-desc">High-level maturity per scheme: Initiated → APSO Approved → Contracted → Execution → Closed.</p>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <div class="main-dash-lifecycle-cards">
        <div class="main-dash-lifecycle-card" *ngFor="let m of chart3SchemeMetrics">
          <h4 class="main-dash-lifecycle-scheme">{{ m.scheme }}</h4>
          <div class="main-dash-lifecycle-chart-wrap">
            <div class="main-dash-lifecycle-chart">
              <p-chart type="pie" [data]="getLifecyclePieData(m)" [options]="chart3PieOptions"></p-chart>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </p-card>
</section>

<!-- ===== CHART 8: Seek Proposal Analytics ===== -->
<!-- <section class="main-dash-section main-dash-chart-section main-dash-chart-row-two">
  <p-card styleClass="main-dash-chart-card">
    <ng-template pTemplate="header">
      <div class="main-dash-chart-header">
        <div>
          <h3 class="main-dash-chart-title">Directorate Response Summary</h3>
          <p class="main-dash-chart-desc">Combined MAKE &amp; TDF seek analytics (submitted, nil return, no response).</p>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <div class="main-dash-chart-wrap main-dash-chart-doughnut">
        <p-chart type="doughnut" [data]="chart8aData" [options]="chart8aOptions"></p-chart>
      </div>
    </ng-template>
  </p-card>
  <p-card styleClass="main-dash-chart-card">
    <ng-template pTemplate="header">
      <div class="main-dash-chart-header">
        <div>
          <h3 class="main-dash-chart-title">Proposal Generation by Seek Proposal</h3>
          <p class="main-dash-chart-desc">Total proposals generated from MAKE and TDF seek proposals.</p>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <div class="main-dash-chart-wrap main-dash-chart-bar">
        <p-chart type="bar" [data]="chart8bData" [options]="chart8bOptions"></p-chart>
      </div>
    </ng-template>
  </p-card>
</section> -->

